'use client';
import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { updateSearchParams } from '@overlapdev/functions';

import { CircleArrowSVG, CloseSVG } from 'components/svg';

const SiteSearchBar = ({}) => {
	//__Hooks
	const pathname = usePathname();
	const searchParams = useSearchParams();

	//__State
	const [value, setValue] = useState('');

	//__Use Effect
	//Update value state if searchParams present
	useEffect(() => {
		if (searchParams?.has('search') && value !== searchParams.get('search')) {
			setValue(searchParams.get('search') || '');
		}
	}, [searchParams]);

	//__Functions
	const change = (e: React.ChangeEvent<HTMLInputElement>) => {
		const field = e.target;
		setValue(field.value);
	};
	const focus = (e: React.ChangeEvent<HTMLInputElement>) => {
		change(e);
	};

	const submit = (e: any) => {
		e.preventDefault();
		if (value !== searchParams.get('search')) {
			window.history.pushState(null, '', `${pathname}?${updateSearchParams(searchParams.toString(), 'search', value, 'p')}`);
		}
	};

	const clear = () => {
		setValue('');
		if (searchParams?.has('search')) {
			window.history.pushState(null, '', `${pathname}?${updateSearchParams(searchParams.toString(), 'search', '', 'p')}`);
		}
	};

	return (
		<form className='flex gap-3 max-sm:flex-col' onSubmit={submit} noValidate>
			<div className='grow overflow-hidden relative'>
				<input type='text' id='news_search_bar' name='news_search_bar' placeholder='What are you looking for?' className='min-w-70' value={value} onChange={(e) => change(e)} onFocus={focus} />
				{value !== '' ? (
					<span className='absolute cursor-pointer m-auto top-[50%] translate-y-[-50%] right-5' role='button' onClick={() => clear()}>
						<CloseSVG className='opacity-60' width={14} />
						<span className='hidden'>Close</span>
					</span>
				) : null}
			</div>
			<button type='submit' className='btn btn_small'>
				<CircleArrowSVG width={18} />
				<span>Search</span>
			</button>
		</form>
	);
};

export default SiteSearchBar;
